// src/google-drive-api.js
export class GoogleDriveAPI {
  constructor(folderId) {
    this.folderId = folderId;
    this.appsScriptUrl = 'https://script.google.com/macros/s/AKfycbyfKs3sXi6lpMCtQoz7WgAmH9HqPzR1z0piJBioUb6VLs-7HWuCL-o53rNiWcrKXLop/exec';
  }

  async fetchImages() {
    try {
      console.log('🔗 Calling Google Drive API for folder:', this.folderId);
      
      const response = await fetch(
        `${this.appsScriptUrl}?folderId=${this.folderId}`, 
        {
          method: 'GET',
          mode: 'cors',
          headers: { 'Accept': 'application/json' }
        }
      );

      if (!response.ok) {
        console.error('❌ API response error:', response.status);
        return [];
      }

      const data = await response.json();
      console.log('📦 API Data:', data);
      
      if (data.success && data.images && data.images.length > 0) {
        console.log(`✅ Found ${data.images.length} images`);
        
        // Return images with multiple URL formats
        return data.images.map((image) => ({
          id: image.id,
          src: this.getDirectImageUrl(image.id), // Primary URL
          thumbnail: this.getThumbnailUrl(image.id),
          alt: this.formatImageName(image.name),
          displayName: this.formatImageName(image.name),
          fileName: image.name,
          // Alternative URL formats
          altUrl1: `https://lh3.googleusercontent.com/d/${image.id}=w800-h600`,
          altUrl2: `https://drive.google.com/thumbnail?id=${image.id}&sz=w800`
        }));
      }
      
      return [];
      
    } catch (error) {
      console.error('❌ Google Drive API error:', error.message);
      return [];
    }
  }

  getDirectImageUrl(fileId) {
    // Main URL format
    return `https://drive.google.com/uc?export=view&id=${fileId}`;
  }

  getThumbnailUrl(fileId) {
    // Thumbnail URL
    return `https://drive.google.com/thumbnail?id=${fileId}&sz=w400`;
  }

  formatImageName(fileName) {
    return fileName
      .replace(/\.[^/.]+$/, "")
      .replace(/[_-]/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }
}